<template>
  <v-dialog
    :value="open"
    content-class="clipDialogMessage"
    max-width="395px"
    @click:outside="handleOutside"
  >
    <v-btn
      icon
      class="clipDialogMessage-closeIcon"
      tabindex="-1"
      @click="$emit('onClose')"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card>
      <div class="clipDialogMessage-message-text" v-html="message"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClipDialogMessage',
  props: {
    open: {
      type: Boolean,
    },
    message: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    handleOutside(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss">
.clipDialogMessage {
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  position: relative;
  &-closeIcon {
    &.v-btn {
      &.v-btn--icon.v-size--default {
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 1;
      }

      .v-icon {
        margin-right: 0;
        font-size: 20px;
        color: #999;
        font-weight: bold;
      }

      &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
      &.theme--light:hover::before {
        opacity: 0;
      }
    }
  }
  &-message-text {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #4b4b4b;
  }
}
</style>
